
import React from "react";
import "./Toggle.css"
const Toggle= ({state,toggleState}) =>{
    
return(
       <div  className="popup-input-card">
       
        <label   class="switchmute ">
 <input id="togglemute" checked={state} onChange={e=>toggleState(e.target.checked)}  type="checkbox"  
    /> 
  <span class="sliderlfmute round"></span>
</label>
    
    </div>
    
)

}

export default Toggle;

